/** Shared Finance UI surfaces — flat, sharp edges (no rounded card shells). */
export const financeShellSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 0,
  bgcolor: 'background.paper',
  overflow: 'hidden',
} as const;

export const financeTabsSx = {
  minHeight: 44,
  px: 0,
  borderBottom: '1px solid',
  borderColor: 'divider',
  '& .MuiTabs-indicator': {
    height: 2,
    bgcolor: 'primary.main',
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    minHeight: 44,
    px: 2.5,
    color: 'text.secondary',
    borderRadius: 0,
    '&.Mui-selected': {
      color: 'text.primary',
    },
  },
} as const;

export const financePanelBodySx = {
  p: { xs: 0, sm: 0 },
} as const;

export const financeMetricSx = {
  p: 2.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 0,
  bgcolor: 'background.paper',
  height: '100%',
  position: 'relative' as const,
  cursor: 'pointer',
  transition: 'background-color 0.15s ease, border-color 0.15s ease',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 2,
    bgcolor: 'primary.main',
  },
  '&:hover': {
    bgcolor: 'action.hover',
    borderColor: 'primary.main',
  },
} as const;

export const financeChartSx = {
  p: 2.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 0,
  bgcolor: 'background.paper',
  height: '100%',
} as const;

export const financeRowSx = {
  px: 2.5,
  py: 2,
  borderBottom: '1px solid',
  borderColor: 'divider',
  borderRadius: 0,
  bgcolor: 'background.paper',
  '&:last-of-type': {
    borderBottom: 'none',
  },
  '&:hover': {
    bgcolor: 'rgba(26, 46, 26, 0.02)',
  },
} as const;

export const financeListSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 0,
  bgcolor: 'background.paper',
  overflow: 'hidden',
} as const;

export const financeToolbarSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  flexWrap: 'wrap' as const,
  px: 2.5,
  py: 1.75,
  borderBottom: '1px solid',
  borderColor: 'divider',
  bgcolor: 'rgba(26, 46, 26, 0.02)',
} as const;

export const financeSectionTitleSx = {
  fontWeight: 700,
  fontSize: '0.8rem',
  letterSpacing: '0.06em',
  textTransform: 'uppercase' as const,
  color: 'text.secondary',
  mb: 1.5,
} as const;
